import { render, staticRenderFns } from "./ArticleAdultLayer.vue?vue&type=template&id=7d68883c&scoped=true"
import script from "./ArticleAdultLayer.vue?vue&type=script&lang=ts"
export * from "./ArticleAdultLayer.vue?vue&type=script&lang=ts"
import style0 from "./ArticleAdultLayer.vue?vue&type=style&index=0&id=7d68883c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d68883c",
  null
  
)

export default component.exports